'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var Paragraph = require('@narvar/nth-bit-paragraph');
var TextInput = require('@narvar/nth-block-text-input');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Panel = require('@narvar/nth-block-panel');
var PanelHeader = require('@narvar/nth-bit-panel-header');
var Button = require('@narvar/nth-block-button');
var Divider = require('@narvar/nth-bit-divider');
var Steps = require('./Steps.js');
var index = require('../../components/Language/index.js');
var Spinner = require('../../components/Spinner/Spinner.js');
require('@babel/runtime/helpers/extends');
var LocationCard = require('../../components/LocationCard/LocationCard.js');
require('../../components/PudoCard/PudoCard.js');
var ItemCard = require('../../components/ItemCard/ItemCard.js');
require('../../components/SelectItem/SelectItem.js');
require('../../components/SelectList/SelectList.js');
var ErrorBanner = require('../../components/ErrorBanner/ErrorBanner.js');
require('../../components/Footer/Footer.js');
require('../../components/StickyFooter/StickyFooter.js');
require('../../components/SwatchesList/SwatchesList.js');
var index$1 = require('../../components/TextLink/index.js');
require('../../components/Backdrop/Backdrop.module.css.js');
require('../../components/LineItemsGroup/index.js');
var ItemCardSkeleton = require('../../components/Skeleton/ItemCardSkeleton.js');
var LineItemSkeleton = require('../../components/Skeleton/LineItemSkeleton.js');
require('../../components/Skeleton/Skeleton.module.css.js');
var useLanguage = require('../../hooks/language/useLanguage.js');
var helper = require('../ItemSelector/helper.js');
var tokens = require('./tokens.js');
var validateString = require('../../utils/validateString.js');
require('@babel/runtime/helpers/defineProperty');
require('escape-string-regexp');
var PreferencesStatus = require('../../components/Preferences/PreferencesStatus.js');
var Confirmation_module = require('./Confirmation.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);
var Panel__default = /*#__PURE__*/_interopDefaultLegacy(Panel);
var PanelHeader__default = /*#__PURE__*/_interopDefaultLegacy(PanelHeader);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);

const ConfirmationRawC = _ref => {
  let {
    error,
    loading,
    shipment,
    type,
    providerMoniker,
    email,
    location,
    alternateEmailToggle = false,
    noInstructions,
    onSubmit,
    newEmailStatus,
    preferencesStatus,
    isHipaaCompliant,
    returnSteps = [],
    locale,
    includeCurrency
  } = _ref;
  const {
    itemDisplay
  } = nthHookSettings.useSettings();
  const [showAlternateEmailForm, setAlternateEmailForm] = React.useState(false);
  const [emailAddress, setUpdatedEmail] = React.useState('');
  const [validationError, setValidationError] = React.useState(false);
  const {
    items,
    returnLabels
  } = shipment || {};
  const mappedUrls = (returnLabels === null || returnLabels === void 0 ? void 0 : returnLabels.reduce((acc, _ref2) => {
    let {
      labelType,
      labelUrl
    } = _ref2;
    if (labelType === 'QR_CODE') {
      return {
        ...acc,
        qrCodeUrl: labelUrl
      };
    }
    return {
      ...acc,
      printLabelUrl: labelUrl
    };
  }, {})) || {};
  const {
    qrCodeUrl,
    printLabelUrl
  } = mappedUrls;
  const {
    value: provider
  } = useLanguage["default"]({
    langKey: `returnsMoniker${providerMoniker ?? ''}DisplayName`,
    asString: true
  });
  const {
    rawValue: skuLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfoskuLabel'
  });
  const {
    rawValue: qtyLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfoqtyLabel'
  });
  const {
    rawValue: colorLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfocolorLabel'
  });
  const {
    rawValue: sizeLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfosizeLabel'
  });
  const {
    rawValue: reasonLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInforeasonLabel'
  });
  const {
    rawValue: placeholder
  } = useLanguage["default"]({
    langKey: 'returnsConfirmationActionsPanelEmailInputPlaceholder'
  });
  const {
    linksNoneDefault,
    linksNoneHover,
    buttonsPrimaryDefault,
    buttonsPrimaryHover,
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  React.useEffect(() => {
    if ((newEmailStatus === null || newEmailStatus === void 0 ? void 0 : newEmailStatus.status) === 'success') {
      setAlternateEmailForm(false);
      setUpdatedEmail('');
    }
  }, [newEmailStatus === null || newEmailStatus === void 0 ? void 0 : newEmailStatus.status]);
  if (loading) {
    return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(ItemCardSkeleton.ItemCardSkeleton, null), /*#__PURE__*/React__default["default"].createElement(LineItemSkeleton.LineItemSkeleton, null), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement(LineItemSkeleton.LineItemSkeleton, null), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement(LineItemSkeleton.LineItemSkeleton, null), /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement(LineItemSkeleton.LineItemSkeleton, null), /*#__PURE__*/React__default["default"].createElement(ItemCardSkeleton.ItemCardSkeleton, null));
  }
  if (error) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        ...bodytextDefaultNone
      }
    }, /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: "returnsConfirmationError"
    })));
  }
  const toggleAlternateEmailForm = () => {
    setAlternateEmailForm(!showAlternateEmailForm);
  };
  const submitAlternateEmailForm = () => {
    const validEmail = validateString.validatePattern(emailAddress ?? '', validateString.EMAIL_ADDRESS_PATTERN);
    if (validEmail) {
      setValidationError(false);
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
        event: 'submit',
        area: 'returnConfirmation',
        subComponent: 'emailSubmittedReturnDetails',
        value: {
          emailAddress
        }
      });
    } else {
      setValidationError(true);
    }
  };
  const langKeySuffix = isHipaaCompliant ? 'Hipaa' : '';
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      ...bodytextDefaultNone
    }
  }, preferencesStatus && /*#__PURE__*/React__default["default"].createElement(PreferencesStatus["default"], preferencesStatus), /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    header: /*#__PURE__*/React__default["default"].createElement(PanelHeader__default["default"], null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: `returnsConfirmation${type ?? ''}ActionsPanelHeader`
    }))
  }, /*#__PURE__*/React__default["default"].createElement("header", {
    className: Confirmation_module["default"].confirmationHeader
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: `returnsConfirmation${type ?? ''}ActionsPanelTitle${langKeySuffix}`,
    replacementTokens: useLanguage.generateTokensFromObject({
      provider
    })
  })), !qrCodeUrl && printLabelUrl && !isHipaaCompliant && /*#__PURE__*/React__default["default"].createElement("div", {
    className: Confirmation_module["default"].btnContainer
  }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    href: printLabelUrl
  }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: `returnsConfirmation${type ?? ''}ActionsPanelMainButton`
  })))), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: `returnsConfirmation${type ?? ''}ActionsPanelDescription${langKeySuffix}`,
    replacementTokens: useLanguage.generateTokensFromObject({
      email: newEmailStatus !== null && newEmailStatus !== void 0 && newEmailStatus.email ? newEmailStatus === null || newEmailStatus === void 0 ? void 0 : newEmailStatus.email : email,
      provider
    })
  })), alternateEmailToggle && !isHipaaCompliant && /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    linkStyle: {
      sDefault: {
        ...linksNoneDefault,
        color: buttonsPrimaryDefault === null || buttonsPrimaryDefault === void 0 ? void 0 : buttonsPrimaryDefault.backgroundColor
      },
      sHover: {
        ...linksNoneHover,
        color: buttonsPrimaryHover === null || buttonsPrimaryHover === void 0 ? void 0 : buttonsPrimaryHover.backgroundColor
      }
    },
    onClick: toggleAlternateEmailForm
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: `returnsConfirmation${type ?? ''}ActionsPanelEmailButton`
  })), showAlternateEmailForm && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Confirmation_module["default"].alternateEmailForm
  }, /*#__PURE__*/React__default["default"].createElement(TextInput__default["default"], {
    value: emailAddress,
    onChange: e => {
      setUpdatedEmail(e.target.value);
    },
    placeholder: placeholder,
    type: TextInput.SupportedInputType.email
  }), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    onClick: submitAlternateEmailForm,
    disabled: (newEmailStatus === null || newEmailStatus === void 0 ? void 0 : newEmailStatus.status) === 'loading' || email === ''
  }, (newEmailStatus === null || newEmailStatus === void 0 ? void 0 : newEmailStatus.status) === 'loading' ? /*#__PURE__*/React__default["default"].createElement(Spinner["default"], null) : /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: `returnsActionsSubmit`
  }))), /*#__PURE__*/React__default["default"].createElement("div", null, validationError && /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: `returnsConfirmationActionsPanelEmailStatusvalidationerror`
  }), /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: `returnsConfirmationActionsPanelEmailStatus${(newEmailStatus === null || newEmailStatus === void 0 ? void 0 : newEmailStatus.status) ?? ''}`
  })))), qrCodeUrl && !isHipaaCompliant && /*#__PURE__*/React__default["default"].createElement("div", {
    className: Confirmation_module["default"].imgContainer
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    style: {
      width: '100%'
    },
    src: qrCodeUrl,
    alt: ""
  })))), location && /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    header: /*#__PURE__*/React__default["default"].createElement(PanelHeader__default["default"], null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: `returnsConfirmation${type ?? ''}LocationPanelHeader`
    }))
  }, /*#__PURE__*/React__default["default"].createElement(LocationCard["default"], {
    location: location,
    active: true,
    transparent: true
  })), !noInstructions && /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    header: /*#__PURE__*/React__default["default"].createElement(PanelHeader__default["default"], null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: `returnsConfirmation${type ?? ''}InstructionsPanelHeader`
    }))
  }, /*#__PURE__*/React__default["default"].createElement("main", null, /*#__PURE__*/React__default["default"].createElement(Steps["default"], {
    steps: returnSteps
  }))), /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    header: /*#__PURE__*/React__default["default"].createElement(PanelHeader__default["default"], null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: `returnsConfirmation${type ?? ''}ItemsPanelHeader`
    }))
  }, items === null || items === void 0 ? void 0 : items.map(item => /*#__PURE__*/React__default["default"].createElement(ItemCard.ItemCard, {
    thumbnail: item.imageUrl,
    title: item.name,
    key: `${item.sku ?? ''}${item.itemId ?? ''}`,
    attributes: helper.getItemAttrs({
      locale,
      includeCurrency,
      item,
      itemDisplay,
      labels: {
        skuLabel,
        qtyLabel,
        colorLabel,
        sizeLabel
      }
    }),
    additionalInfo: item.reason.name && `${reasonLabel ?? ''}${item.reason.name}`,
    hasShippingProtection: item.hasShippingProtection
  }))), qrCodeUrl && printLabelUrl && /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    header: null
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: `returnsConfirmation${type ?? ''}SecondaryActionsPanelTitle`
  })), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: `returnsConfirmation${type ?? ''}SecondaryActionsPanelDescription`
  })), /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    linkStyle: {
      sDefault: {
        ...buttonsPrimaryDefault,
        color: (buttonsPrimaryDefault === null || buttonsPrimaryDefault === void 0 ? void 0 : buttonsPrimaryDefault.backgroundColor) || '#000000',
        backgroundColor: 'none',
        textTransform: 'none'
      }
    },
    href: printLabelUrl
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: `returnsConfirmation${type ?? ''}SecondaryActionsPanelMainButton`
  }))));
};
const ConfirmationRaw = nthHookSettings.withSettingsProvider(nthHookTheme.withThemeProvider(ConfirmationRawC, {
  themeTokens: tokens.themeTokens
}), {
  settingsRequested: `
      itemDisplay {
        additionalItemAttributeConfig {
          attribute
          value {
            concatKey
            concatPosition
            label
            transform
          }
        }
        itemAttributeConfig
      }
    `
});

exports.ConfirmationRaw = ConfirmationRaw;
